import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { AgentTitleService } from './agent-title.service';
import AgentView from './agent-view/agent-view.module.ajs';
import CenterView from './center-view/center-view.module.ajs';
import ContactView from './contact-view/contact-view.module.ajs';
import Helpzone from './helpzone/helpzone.module.ajs';

export default module('contact.agent.desktop', [AgentView, CenterView, ContactView, Helpzone])
  // DOWNGRADED SERVICE
  .factory('agentTitleService', downgradeInjectable(AgentTitleService) as any).name;
